import { useEffect } from "react";
import { CalendarDays } from "lucide-react";
import { BUSINESS } from "../data/site";

export const buildCalendlyUrl = (scopeText) => {
  const u = new URL(BUSINESS.calendlyUrl);
  u.searchParams.set("hide_gdpr_banner", "1");
  u.searchParams.set("primary_color", "ef6c14");
  u.searchParams.set("embed_type", "Inline");
  u.searchParams.set("embed_domain", window.location.hostname);
  if (scopeText) u.searchParams.set("a1", scopeText);
  return u.toString();
};

// Calendly inline embed. Calls onScheduled when Calendly reports a booked event.
export const CalendlyEmbed = ({ scopeText, onScheduled, height = 640, testId = "calendly-embed-container" }) => {
  useEffect(() => {
    const handler = (e) => {
      if (typeof e.data === "object" && e.data?.event === "calendly.event_scheduled") onScheduled?.();
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [onScheduled]);

  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-white" data-testid={testId} data-lenis-prevent>
      <div className="flex items-center gap-2 border-b border-slate-200 px-4 py-3 text-xs font-semibold text-slate-600">
        <CalendarDays className="h-4 w-4 text-flame-600" /> Live calendar · Pick a 30-minute visit
      </div>
      <iframe title="Book your Amora Colour & Scope Visit" src={buildCalendlyUrl(scopeText)} className="w-full" style={{ height }} loading="lazy" />
    </div>
  );
};

export const TrustMicrocopy = ({ dark = false }) => (
  <ul className={`grid gap-1.5 text-xs leading-relaxed sm:text-[13px] ${dark ? "text-slate-300" : "text-slate-600"}`} data-testid="booking-trust-microcopy">
    <li>Free to book — nothing due until you approve the written quote.</li>
    <li>Reschedule or cancel free anytime from your confirmation link.</li>
  </ul>
);
